<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div>
        <div v-if="role===0 || role===1" class="table-top-wrapper">
            <el-row>
                <el-col :span="24" class="condition-panel"
                        style="display: flex;flex-direction: row;justify-content: space-between;">
                    <el-col :span="2">
                        <el-button type="primary" v-if="role===0" @click="handleUserDialog(1)">添加</el-button>
                    </el-col>
                    <el-col :span="22" style="display: flex;flex-direction: row;justify-content: end;">
                        <el-form :inline="true">
                            <el-form-item label="用户名" style="margin-right: 10px !important;">
                                <el-input @keyup.enter="getUser(true)" v-model="userSelect.user.username"
                                          type="text"></el-input>
                            </el-form-item>
                            <el-form-item label="性别" style="margin-right: 10px !important;">
                                <el-radio-group @input="getUser(true)" v-model="userSelect.user.sex">
                                    <el-radio-button label="1">男</el-radio-button>
                                    <el-radio-button label="2">女</el-radio-button>
                                    <el-radio-button label="">全部</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item>
                                <el-button style="margin-left: 20px;" @click="reset()" type="danger">重置</el-button>
                                <el-button style="margin-left: 20px;" @click="getUser(true)" type="primary">查询
                                </el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-col>
            </el-row>
        </div>

        <div class="table-wrapper">
            <el-table
                    :header-cell-style="$store.state.style.table.headerCellStyle"
                    :cell-style="$store.state.style.table.cellStyle"
                    :header-row-style="$store.state.style.table.headerRowStyle"
                    :row-style="$store.state.style.table.rowStyle"
                    :row-class-name="tableClass"
                    
                    key="UserManage"
                    width="100%"
                    :data="users">
                <el-table-column label="主键" prop="id"></el-table-column>
                <el-table-column label="用户名" prop="username"></el-table-column>
                <el-table-column label="密码" prop="password"></el-table-column>
                <el-table-column label="性别" prop="sex"></el-table-column>
                <el-table-column label="头像">
                    <template slot-scope="scope">
                        <img :src="$store.state.backendHost+scope.row.img.split(',')[0]" width="50px" alt="">
                    </template>
                </el-table-column>
                <el-table-column width="380" label="操作">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: center;flex-direction: row">
                            <el-button v-if="role===0" type="primary" @click="handleUserDialog(2,scope.row)"
                                       icon="el-icon-edit"></el-button>
                            <el-popover
                                    v-if="role===0 && scope.row.role !==0"
                                    placement="top"
                                    key="UserManage"
                                    style="margin-left: 10px"
                                    v-model="scope.row.visible">
                                <p style="text-align: center">真的要删除吗?</p>
                                <div>
                                    <el-button type="danger" @click="deleteUser(scope.row,scope.$index)">确定
                                    </el-button>
                                    <el-button type="success" @click="scope.row.visible=false">取消</el-button>
                                </div>
                                <el-button icon="el-icon-delete" type="danger" slot="reference"></el-button>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-pg-wrapper">
                <el-pagination
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page.sync="userSelect.pageVo.pageIndex"
                        :page-size.sync="userSelect.pageVo.pageSize"
                        @size-change="getUser(false)"
                        @current-change="getUser(false)"
                        :page-sizes="[5, 10, 50, 100]"
                        :total.sync="userSelect.pageVo.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="userDialogVisible" width="40%" :close-on-click-modal="false">
            <el-form label-width="150px" label-position="left" :model="user">
                <el-form-item label="用户名" style="margin-right: 10px !important;">
                    <el-input v-model="user.username" type="text"></el-input>
                </el-form-item>
                <el-form-item label="密码" style="margin-right: 10px !important;">
                    <el-input v-model="user.password" type="text"></el-input>
                </el-form-item>
                <el-form-item label="性别" style="margin-right: 10px !important;">
                    <el-radio-group v-model="user.sex">
                        <el-radio-button label="1">男</el-radio-button>
                        <el-radio-button label="2">女</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="角色" style="margin-right: 10px !important;">
                    <el-radio-group v-model="user.role">
                        <el-radio-button label="1">管理员</el-radio-button>
                        <el-radio-button label="2">用户</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="头像链接上传">
                    <el-upload ref="upload" :action="$store.state.backendHost+'/upload'" :on-success="uploadSucc"
                               :auto-upload="false">
                        <el-button slot="trigger" size="small" type="primary">选取头像链接</el-button>
                        <el-button size="small" type="success" @click="submitUpload" style="margin-left: 10px">
                            上传头像链接
                        </el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="头像链接">
                    <img :src="$store.state.backendHost+user.img" width="150px" alt="">
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
           <el-button @click="userDialogVisible = false">取消</el-button>
           <el-button type="primary" @click="handleUserDialogConfirm">保存</el-button>
       </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "UserManage",
    watch: {},
    data() {
        return {
            role: this.$store.state.loginUser.role,
            userSelect: {
                user: {
                    id: null,
                    username: '',
                    password: '',
                    sex: 0,
                    role: 0,
                    img: '',
                },
                pageVo: {
                    pageSize: 5,
                    pageIndex: 1,
                    total: 0
                }
            },
            user: {
                id: null,
                username: '',
                password: '',
                sex: 0,
                role: 0,
                img: '',
            },
            users: [],
            selectedUser: {},
            userDialogMode: 1,
            userDialogVisible: false,
        }
    },
    filters: {
        ellipsis(value) {
            if (!value) return "";
            if (value.length > 10) {
                return value.slice(0, 10) + "...";
            }
            return value;
        }
    },
    methods: {
        reset() {
            this.userSelect.user = {}
            this.getUser(true)
        },
        //crud
        insertUser() {
            let data = JSON.stringify(this.user)
            this.$axios({
                url: "/user/insert",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data > 0) {
                    this.user.id = r.data
                    this.users.push(this.user)
                    this.userSelect.pageVo.total++
                    this.$message.success('创建成功');
                } else {
                    this.$message.error('创建失败');
                }
            })
        },
        dup(o) {
            this.user = o
            this.insertUser()
        },
        deleteUser(user, index) {
            this.$axios({
                url: "/user/delete?id=" + user.id,
                method: 'get',
                headers: {'content-type': 'application/json'},
            }).then((r) => {
                if (r.data === 1) {
                    this.users.splice(index, 1)
                    this.$message.success('删除成功');
                } else {
                    this.$message.error('删除失败');
                }
            })
        },
        modifyUser() {
            let data = JSON.stringify(this.user)
            this.$axios({
                url: "/user/update",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                if (r.data === 1) {
                    this.$message.success('修改成功');
                } else {
                    this.$message.error('修改失败');
                }
            })
        },
        getUser(resetPageIndex) {
            if (resetPageIndex) {
                this.userSelect.pageVo.pageIndex = 1
            }
            let data = JSON.stringify(this.userSelect)
            this.$axios({
                url: "/user/select",
                method: 'post',
                headers: {'content-type': 'application/json'},
                data: data
            }).then((r) => {
                this.users = r.data.users
                this.userSelect.pageVo.total = r.data.total
            })
        },
        //crud public
        handleUserDialog(mode, user) {
            this.userDialogMode = mode
            this.userDialogVisible = true
            if (mode === 1) {
                this.user = {
                    id: null,
                    username: '',
                    password: '',
                    sex: 0,
                    role: 0,
                    img: '',
                }
            }
            if (mode === 2) {
                this.user = user
            }
        },
        handleUserDialogConfirm() {
            if (this.userDialogMode === 1) this.insertUser()
            if (this.userDialogMode === 2) this.modifyUser()
            this.userDialogVisible = false
        },
        submitUpload() {
            this.$refs.upload.submit()
        },
        uploadSucc(response, file) {
            this.user.img = response
        },
        //common
        tableClass({row, rowIndex}) {
            return rowIndex % 2 === 1 ? "even-row" : "no-even-row"
        },
    },
    mounted() {
        this.reset()
    },
}
</script>
<style scoped>
.el-radio-button__inner {
    border: 0 !important;
    border-radius: 0 !important;
    /*background-color: transparent !important;*/
}
</style>